import {adjustFromTimeZoneSafely, TransportEntity, transportType,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {toFormDefaultsFromTransport} from "../TransportFormPage/TransportFormPage";

export type UseTicketFormPageNavigateProps = {}

export type UseTicketFormPageNavigateResult = {
  navigate: (transport: TransportEntity) => void;
}

export const useTicketFormPageNavigate = (props: UseTicketFormPageNavigateProps = {}): UseTicketFormPageNavigateResult => {
  const {} = props

  const navigate = useNavigate();

  const _transportNavigate = useCallback((transport: TransportEntity) => {
    navigate("/tickets/form", {
      state: transport?.type === transportType.pickup ? {
        database: transport?.dbName,
        pickupId: transport?.id,
        formDefaults: {
          pickup: toFormDefaultsFromTransport(transport),
          delivery: {
            date: adjustFromTimeZoneSafely(transport.createDttm)
          }
        },
        options: {
          category: transport.category,
          categoryDisabled: true,
        }
      } : {
        database: transport?.dbName,
        deliveryId: transport?.id,
        formDefaults: {
          pickup: {
            date: adjustFromTimeZoneSafely(transport?.createDttm)
          },
          delivery: toFormDefaultsFromTransport(transport)
        },
        options: {
          category: transport?.category,
          categoryDisabled: true,
        }
      },
    });
  }, [navigate])

  return {
    navigate: _transportNavigate,
  }
}
